import {
  useCallback,
  FunctionComponent,
  SyntheticEvent,
  useEffect,
  ChangeEvent,
  useMemo,
  useState,
  useRef,
} from 'react';
import _ from 'lodash';
import {
  OpenCaseInput as OpenCaseInputTypes,
  OpenCase as OpenCaseTypes,
} from '~types';
//import { Button, ButtonProps } from '~ui/Button';
import { ButtonProps } from '~ui/Button';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useMutation, gql } from '@apollo/client';
import { setTimeout } from 'isomorphic-timers-promises';
import { Price, convertNumber } from '~ui/Price';
import { useConfig, useProfile } from '~components/hooks';

import { useGetCase } from '../../home/hooks';
import { useOpenModal } from '../../modals/hooks';
import {
  useGameCount,
  useStatusGame,
  useGames,
  useSliderStyle,
  useSliderOpenStyle,
  useFastMode,
  useSuperPrizeMode,
  useCalceOfPossibleFreeOpenPrice,
} from '../hooks';
import playAudio from '~frontend/utils/playAudio';
import FormatDate from '../../home/cases/FormatDate';
import Tab from '~shared/frontend/ui/tab/tab';
import Switch from '~shared/frontend/ui/switch/switch';
import { Button } from '~shared/frontend/ui/button/button';
import SwitchIcon from './switch';
import SwitchSec from './switch-sec';
import { useKeyPressEvent } from 'react-use';
import '~shared/frontend/ui/tab/tab.scss';
import './caseActions.scss';
import Currency from '~frontend/components/Currency';
import Info from './info';
import { useCookies } from 'react-cookie';

interface CSSStyleDeclarationMoz extends CSSStyleDeclaration {
  mozTransform: string;
  webkitTransform: string;
}

interface ButtonsCaseMutationData {
  openCase: OpenCaseTypes[];
}

interface ButtonsCaseMutationVars {
  input: OpenCaseInputTypes;
}

let audioInterval = null;
let abortController = new AbortController();

const getTransformOffset = (element: Element) => {
  const style = window.getComputedStyle(element) as CSSStyleDeclarationMoz;
  const matrix = style.transform || style.webkitTransform || style.mozTransform;

  const t = matrix.split(',');

  return 6 === t.length
    ? parseInt(t[4])
    : 16 === t.length
    ? parseInt(t[12])
    : 0;
};

export const OpenCase: FunctionComponent<ButtonProps> = (props) => {
  const [isFastGame] = useFastMode();
  // const [isSuperPrizeGame] = useSuperPrizeMode();
  // const [caseBonusPrice, setCaseBonusPrice] = useState(0);
  const getProfile = useProfile();
  const [cookies, setCookie] = useCookies(['isDemo']);
  console.log('cookies', cookies);
  const [countOpen, setGameCount] = useGameCount();
  const getConfig = useConfig();
  const { onShow } = useOpenModal();
  const [, setGames] = useGames();
  const [gameStatus, setStatus] = useStatusGame();
  const [isGame] = useStatusGame();
  const [isPriorityChecked, setIsPriorityChecked] = useState(true);
  const [isFastEndDisabled, setIsFastEndDisabled] = useState(false);
  const [isDisabledInitiated, setIsDisabledInitiated] = useState(false);
  const [isDemoDisabled, setIsDemoDisabled] = useState(false);

  const [, setSliderStyle] = useSliderStyle();
  const [, setSliderOpenStyle] = useSliderOpenStyle();
  const { t } = useTranslation();

  //console.log('is super open case', isSuperPrizeGame);

  useEffect(() => {
    if (gameStatus === 2 && props.isDemoDisabled) {
      // Полностью отключаем кнопку в демо-режиме
      setIsDemoDisabled(true);
    } else if (gameStatus === 2) {
      // Отключаем кнопку на 2500 миллисекунд в обычном режиме
      setIsFastEndDisabled(true);

      const disableTimer = async () => {
        await setTimeout(2500);
        setIsFastEndDisabled(false);
      };

      disableTimer();
    }
  }, [gameStatus, props.isDemoDisabled]);

  // useEffect(() => {
  //   if (gameStatus === 2 && props.isDemo && !props.isFastEnd) {
  //     setCookie('isDemo', true);
  //   }
  // }, [gameStatus, props.isDemo, props.isFastEnd]);

  const {
    data: { getCase },
    refetch,
  } = useGetCase({});

  const [openCase, { loading }] = useMutation<
    ButtonsCaseMutationData,
    ButtonsCaseMutationVars
  >(
    gql`
      mutation OpenCase($input: OpenCaseInput!) {
        openCase(input: $input) {
          getCategory {
            id
            getName
          }
          getGame {
            id
            status
            price
            priceSell
            chance
            getCase {
              id
              price
            }
            getItem {
              id
              getName
              getImage
              color
              quality
              price
            }
          }
          getItems {
            id
            getName
            getImage
            color
            quality
          }
        }
      }
    `,
  );
  // const casePrice = getCase.price / 100;
  // const isBlogger = getProfile?.group === 4 ? true : false;
  // const bonusFormula = getConfig.caseBonusPrizeFormula?.props.find(
  //   (item) => casePrice > item.minCasePrice && casePrice < item.maxCasePrice,
  // );

  // const superGameFactor = isBlogger
  //   ? bonusFormula.bloggerCaseCostFactor
  //   : bonusFormula.caseCostFactor;

  // console.log('superGameFactor', superGameFactor);

  // useEffect(() => {
  //   setCaseBonusPrice(0);
  //   const newCaseBonusPrice = isSuperPrizeGame
  //     ? casePrice + casePrice * superGameFactor
  //     : 0;

  //   console.log('newCaseBonusPrice', newCaseBonusPrice);
  //   setCaseBonusPrice(newCaseBonusPrice);
  // }, [isSuperPrizeGame, casePrice, superGameFactor, countOpen]);
  console.log('gameStatus', gameStatus);

  const onFastEnd = useCallback(
    async (event: SyntheticEvent<HTMLElement>) => {
      const isDemo = props.isDemo;
      if (props.isDemoDisabled) return;

      console.log('isDemo', isDemo);

      abortController.abort(); // Останавливаем onOpenCase
      abortController = new AbortController(); // Создаём новый контроллер

      await setTimeout(1500, '');

      const timeout = 5000;

      playAudio(event, 'cs_stinger.wav', 0.2);

      setStatus(3);

      await setTimeout(6500, '', { signal: abortController.signal });

      setSliderOpenStyle({
        opacity: 0,
      });

      await setTimeout(2500, '', { signal: abortController.signal });

      setSliderStyle(null);

      clearInterval(audioInterval);

      setStatus(4);

      setCookie('isDemo', false);

      // if (isDemo) {
      //   const {
      //     data: { openCase: getGames },
      //   } = await openCase({
      //     variables: {
      //       input: {
      //         caseId: getCase?.id,
      //         countOpen,
      //         isFastGame,
      //         isDemo,
      //         //bonusCasePrice: caseBonusPrice * countOpen || 0,
      //       },
      //     },
      //   });
      //   console.log('isDemo11111', isDemo);
      //   onShow('WinDemoModal', { getGame: getGames[0] });

      //   setStatus(0);
      // } else {
      //   if (getCase?.type === 3) {
      //     await refetch();
      //   }
      // }
    },
    [
      setStatus,
      setGames,
      openCase,
      getCase?.id,
      getCase?.price,
      getCase?.getName,
      getCase?.category,
      getCase?.type,
      countOpen,
      isFastGame,
      //isSuperPrizeGame,
      setGameCount,
      getConfig?.getCurrency?.char,
      setSliderStyle,
      setSliderOpenStyle,
      onShow,
      refetch,
      t,
    ],
  );

  const onOpenCase = useCallback(
    async (event: SyntheticEvent<HTMLElement>) => {
      try {
        setStatus(1);
        setGames([]);

        playAudio(event, '12.mp3', 0.2);

        const isDemo = props.isDemo;
        //console.log('isDemo', isDemo);

        if (isDemo) {
          setGameCount(1);
          setCookie('isDemo', true);
        }
        //console.log('isFastGame', isFastGame);
        const {
          data: { openCase: getGames },
        } = await openCase({
          variables: {
            input: {
              caseId: getCase?.id,
              countOpen,
              isFastGame,
              isDemo,
              //bonusCasePrice: caseBonusPrice * countOpen || 0,
            },
          },
        });

        //setCaseBonusPrice(0);

        if (!isDemo) {
          // window?.fbq('track', 'AddToCart', {
          //   content_name: getCase?.getName,
          //   content_type: 'product',
          //   value: convertNumber(getCase?.price),
          //   currency: getConfig?.getCurrency?.char,
          //   content_ids: [getCase?.id],
          //   contents: [{ id: getCase?.id, quantity: countOpen }],
          // });

          window?.dataLayer?.push({ ecommerce: null });
          window?.dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
              currency: getConfig?.getCurrency?.char,
              value: convertNumber(getCase?.price),
              items: [
                {
                  item_name: getCase?.getName,
                  item_id: String(getCase?.id),
                  price: convertNumber(getCase?.price),
                  item_category: String(getCase?.category),
                  quantity: countOpen,
                  currency: getConfig?.getCurrency?.char,
                },
              ],
            },
          });

          for (const { getGame, getCategory } of getGames) {
            window?.dataLayer?.push({ ecommerce: null }); // Clear the previous ecommerce object.
            window?.dataLayer?.push({
              event: 'playCase',
              ecommerce: {
                transaction_id: String(getGame.id),
                value: convertNumber(getCase?.price),
                currency: window['currency'],
                affiliation: 'onOpenCase',
                items: [
                  {
                    item_name: getCase?.getName,
                    item_id: String(getCase?.id),
                    item_category: getCategory?.getName,
                    price: convertNumber(getCase?.price),
                    quantity: 1,
                  },
                ],
              },
            });
          }
        }

        setGames(getGames);
        console.log('props.isFastEnd', props.isFastEnd);

        if (isFastGame) {
          playAudio(event, 'cs_stinger.wav', 0.2);
        } else {
          setStatus(2);
          //Slider Animation duration
          const timeout = 13000;

          await setTimeout(500, '', { signal: abortController.signal });

          const obj = document.querySelector(
            `.case-slider-item:nth-child(${countOpen > 1 ? 70 : 68})`,
          ) as HTMLElement;

          setSliderStyle({
            timeout,
          });

          setSliderOpenStyle({
            opacity: 1,
          });

          let m = 10,
            position = 0;

          audioInterval = setInterval(() => {
            (position = getTransformOffset(
              document
                .querySelectorAll('.case-play-slider')[0]
                .querySelectorAll(`.case-play-slider-wrap`)[0],
            )),
              m - position >= 180 &&
                ((m = position), playAudio(event, 'roulette-start-2.mp3', 0.1));
          }, 80);

          await setTimeout(timeout, '', {
            signal: abortController.signal,
          });

          clearInterval(audioInterval);

          playAudio(event, 'cs_stinger.wav', 0.2);

          setStatus(3);

          await setTimeout(3500, '', { signal: abortController.signal });

          setSliderOpenStyle({
            opacity: 0,
          });

          await setTimeout(500, '', { signal: abortController.signal });

          setSliderStyle(null);
        }

        setStatus(4);

        if (isDemo) {
          onShow('WinDemoModal', { getGame: getGames[0] });

          setStatus(0);
        } else {
          if (getCase?.type === 3) {
            await refetch();
          }
        }
        setCookie('isDemo', false);
      } catch (error) {
        if (!abortController.signal.aborted) {
          setStatus(0);
          toast.error(
            <>
              <div className="notify-title">{t('Error')}!</div>
              <div
                className="notify-text"
                dangerouslySetInnerHTML={{ __html: t(error.message) }}
              />
            </>,
          );
        }
      }
    },
    [
      setStatus,
      setGames,
      openCase,
      getCase?.id,
      getCase?.price,
      getCase?.getName,
      getCase?.category,
      getCase?.type,
      countOpen,
      isFastGame,
      //isSuperPrizeGame,
      setGameCount,
      getConfig?.getCurrency?.char,
      setSliderStyle,
      setSliderOpenStyle,
      onShow,
      refetch,
      t,
    ],
  );

  const disabled = useMemo(() => {
    if (gameStatus >= 3) {
      return true;
    }

    return props?.disabled;
  }, [gameStatus, props?.disabled]);

  const disabledDemo = useMemo(() => {
    return gameStatus >= 3 || props?.disabled || props?.isDemo;
  }, [gameStatus, props?.disabled, props?.isDemo]);

  // console.log('props is demo', props.isDemo);
  // console.log('props is demo', props.isFastEnd);
  return isGame && props.isFastEnd ? (
    <Button
      onClick={onFastEnd}
      //{...props}
      className={`btn1_yellow case_actions_button`}
      text={`Быстрая остановка`}
      //currencyComponent={<Currency />}
      type={'button'}
      disabled={isFastEndDisabled || isDemoDisabled || cookies.isDemo}
      //href={'/pay'}
      //disabled={disabled || getProfile?.money < getCase?.price}
      //loading={loading}
    />
  ) : props.isDemo ? (
    <Button
      onClick={onOpenCase}
      //{...props}
      className={`btn1_blue_bordered case_actions_button_demo`}
      text={t('btn-demo b-violet b-violet-blue')}
      type={'button'}
      disabled={isGame ? true : false}
      //type={'button'}
      //disabled={disabled || getProfile?.money < getCase?.price}
      //loading={loading}
    />
  ) : getProfile?.money < getCase?.price * countOpen ? (
    <Button
      onClick={onOpenCase}
      //{...props}
      className={`btn1_yellow case_actions_button`}
      text={`${t('Top up')} ${
        (getCase?.price * countOpen - getProfile?.money) / 100
      }`}
      currencyComponent={<Currency />}
      href={'/pay'}
      //disabled={disabled || getProfile?.money < getCase?.price}
      //loading={loading}
    />
  ) : (
    <>
      {!isGame && (
        <Button
          onClick={onOpenCase}
          //{...props}
          className={`btn1_yellow case_actions_button`}
          text={`${t('Open')} ${countOpen * (getCase.price / 100)}`}
          type={'button'}
          currencyComponent={<Currency />}
          disabled={disabled || getProfile?.money < getCase?.price}
          //loading={loading}
        />
      )}
    </>
  );
};

// import CleverImage from '../../../scss/images/clover.png';
// console.log('cev', CleverImage);

// // Создаем компонент для иконки с кленом
// const SwitchClever: FunctionComponent = () => {
//   return (
//     <div className="case_actions_switch_clever">
//       <div
//         style={{
//           display: 'flex',
//           justifyContent: 'center',
//           width: '36px',
//         }}
//       >
//         <img
//           src={CleverImage}
//           alt="Clover"
//           style={{ width: '28px', height: '28px' }}
//         />
//       </div>
//     </div>
//   );
// };

const ButtonsCase: FunctionComponent<any> = ({ onFastEndBtnClick }) => {
  const getProfile = useProfile();
  const [, setSliderStyle] = useSliderStyle();
  const [, setSliderOpenStyle] = useSliderOpenStyle();
  const [gameStatus, setStatus] = useStatusGame();
  const { onShow } = useOpenModal();
  const [isFastGame, setFastGame] = useFastMode();
  const [isSuperPrizeGame, setSuperPrizeGame] = useSuperPrizeMode();
  const [countOpen, setGameCount] = useGameCount();
  const [isGame] = useStatusGame();
  const { t } = useTranslation();
  const getConfig = useConfig();
  const [isPriorityChecked, setIsPriorityChecked] = useState(true);

  const isMobile =
    getConfig?.userAgent.match(
      /Android|BlackBerry|iPhone|iPod|Opera Mini|IEMobile|WPDesktop/i,
    ) ?? false;

  const {
    data: { getCase },
  } = useGetCase({});

  useKeyPressEvent(
    ({ code }) => code === 'Digit1',
    () => {
      const button = document.querySelector(
        '.case-select-count-item[data-quant="1"]',
      );

      if (button instanceof HTMLElement) {
        button.click();
      }
    },
  );

  useKeyPressEvent(
    ({ code }) => code === 'Digit2',
    () => {
      const button = document.querySelector(
        '.case-select-count-item[data-quant="2"]',
      );

      if (button instanceof HTMLElement) {
        button.click();
      }
    },
  );

  useKeyPressEvent(
    ({ code }) => code === 'Digit3',
    () => {
      const button = document.querySelector(
        '.case-select-count-item[data-quant="3"]',
      );

      if (button instanceof HTMLElement) {
        button.click();
      }
    },
  );

  useKeyPressEvent(
    ({ code }) => code === 'Digit4',
    () => {
      const button = document.querySelector(
        '.case-select-count-item[data-quant="5"]',
      );

      if (button instanceof HTMLElement) {
        button.click();
      }
    },
  );

  // useKeyPressEvent(
  //   ({ code }) => code === 'Digit5',
  //   () => {
  //     const button = document.querySelector(
  //       '.case-select-count-item[data-quant="10"]',
  //     );

  //     if (button instanceof HTMLElement) {
  //       button.click();
  //     }
  //   },
  // );

  useKeyPressEvent(
    ({ code }) => code === 'KeyO',
    () => {
      const button = document.querySelector('.button[data-type="openCase"]');

      if (button instanceof HTMLElement) {
        button.click();
      }
    },
  );
  useKeyPressEvent(
    ({ code }) => code === 'KeyD',
    () => {
      const button = document.querySelector('.button[data-type="demo"]');

      if (button instanceof HTMLElement) {
        button.click();
      }
    },
  );
  useKeyPressEvent(
    ({ code }) => code === 'KeyQ',
    () => {
      const button = document.querySelector(
        '.btn-fast-open input[type="checkbox"]',
      );

      if (button instanceof HTMLElement) {
        button.click();
      }
    },
  );

  useEffect(() => {
    abortController = new AbortController();

    return () => {
      clearInterval(audioInterval);
      abortController.abort();
      setGameCount(1);
      setStatus(0);
      setSliderOpenStyle({
        opacity: 0,
      });
      setSliderStyle(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toogleFastMode = useCallback(
    (isChecked: boolean) => {
      //console.log('isChecked:', isChecked);
      setFastGame(isChecked);
    },
    [setFastGame],
  );

  const toogleSuperPrizeMode = useCallback(
    (isChecked: boolean) => {
      setSuperPrizeGame(isChecked);
    },
    [setSuperPrizeGame],
  );

  const quant = useCallback(
    (event: SyntheticEvent) => {
      event.preventDefault();

      if (isGame > 0) {
        return false;
      }

      setGameCount(_.toInteger(event.currentTarget.getAttribute('data-quant')));

      return true;
    },
    [isGame, setGameCount],
  );

  const viewModal = useCallback(
    (
      event: SyntheticEvent<HTMLElement>,
      { type, reachgoal } = event.currentTarget.dataset,
    ) => {
      if (event) {
        event.preventDefault();
      }

      if (!type) {
        throw Error('Не указан тип');
      }

      onShow(type, { reachgoal });
    },
    [onShow],
  );

  const [price, priceOld, freeCountOpen, battlePassCoins] =
    useCalceOfPossibleFreeOpenPrice(
      getCase,
      getCase?.userOpenForFree,
      countOpen,
    );

  const disabled = useMemo(() => {
    if (getCase?.type === 7 && freeCountOpen < 1) {
      return true;
    }

    return false;
  }, [getCase?.type, freeCountOpen]);

  // if (isGame) {
  //   return null;
  // }
  console.log('gameStatus', gameStatus);

  return (
    <>
      {/* {getCase?.getDateEnd && (
        <FormatDate
          getCase={getCase}
          className="distribution-item-controls-timer"
        />
      )} */}

      {/* {getCase?.needToOpenForFree > 0 && (
        <div className="case-item-nums">
          <div className="case-item-nums-wrap">
            <span className="icon icon-case-name"></span>
            <span className="red">{getCase?.userOpenForFree}</span>
            <span>&nbsp;/&nbsp;</span>
            <span>{getCase?.needToOpenForFree}</span>
          </div>
        </div>
      )}

      {getCase?.type === 1 && getCase?.getLeft > 0 && (
        <div className="case-item-nums">
          <div className="case-item-nums-wrap">
            <span className="fa fa-bolt icon icon-case-name"></span>
            <span className="red">{getCase?.getLeft}</span>
            <span> / </span>
            <span>{getCase?.getLimit}</span>
          </div>
        </div>
      )} */}

      {![3, 7].includes(getCase?.type) && ![4].includes(gameStatus) && (
        <>
          <div
            className="case_actions_left_group"
            data-rar={price <= 0 ? '06c50c' : getCase?.color}
          >
            <div className="case_quantity">
              {[1, 2, 3, 4, 5].map((item) => (
                <Tab
                  key={item}
                  item={item}
                  isSelected={countOpen === item}
                  text={item}
                  onClick={quant}
                  //icon={tab.icon}
                  className="case_quantity_tab"
                  isDisabled={isGame ? true : false}
                />
              ))}
            </div>

            <div className="case_actions_mobile_switch">
              <div className="sound_switch_container">
                <Switch
                  defaultChecked={true}
                  icon={<SwitchIcon />}
                  className="sound_switch"
                  onChange={toogleFastMode}
                  isDisabled={isGame ? true : false}
                />
              </div>
            </div>
          </div>

          <div className="case_actions_center_group">
            {!getProfile ? (
              <Button
                className={`btn1_yellow case_actions_button`}
                text={t('Login')}
                href={'/auth/steam'}
              />
            ) : (
              <OpenCase data-type="openCase" isFastEnd={true} />
            )}

            {/* {isMobile && (
              <div className="case_actions_switch_wrapper_mobile">
                <div
                  className={`case_actions_switch_info ${
                    !isPriorityChecked
                      ? 'case_actions_switch_info_disabled'
                      : ''
                  }`}
                >
                  {' '}
                  <Info />
                </div>
                <Switch
                  defaultChecked={true}
                  icon={<SwitchClever />}
                  className={`sound_switch switch_large`}
                  onChange={toogleSuperPrizeMode}
                  isDisabled={isGame ? true : false}
                />
              </div>
            )} */}
          </div>

          <div className="case_actions_right_group">
            {/* {!isMobile && (
              <div className="case_actions_switch_wrapper">
                <div
                  className={`case_actions_switch_info ${
                    !isPriorityChecked
                      ? 'case_actions_switch_info_disabled'
                      : ''
                  }`}
                >
                  <Info />
                </div>
                <Switch
                  defaultChecked={isSuperPrizeGame}
                  icon={<SwitchClever />}
                  className={`sound_switch switch_large`}
                  onChange={toogleSuperPrizeMode}
                  isDisabled={isGame ? true : false}
                />
              </div>
            )} */}
            <OpenCase
              isDemo={true}
              isDemoDisabled={true}
              isFastEnd={false}
              data-type="demo"
            />

            <div className="case_actions_desktop_switch">
              <div className="sound_switch_container">
                <span className="fast_open_label">{t('Open quick')}</span>
                <Switch
                  defaultChecked={isFastGame}
                  icon={<SwitchIcon />}
                  className="sound_switch"
                  onChange={toogleFastMode}
                  isDisabled={isGame ? true : false}
                />
              </div>
            </div>
          </div>

          {/* {getProfile?.money > 0 && (
                <div
                  className="case-select-count"
                  data-rar={price <= 0 ? '06c50c' : getCase?.color}
                >
                  {[1, 2, 3, 5].map((item) => (
                    <button
                      key={item}
                      className={`case-select-count-item ${
                        countOpen === item && 'active'
                      }`}
                      onClick={quant}
                      data-quant={item}
                    >
                      <div className="btn-hoykey">
                        {item === 5 ? 4 : item === 10 ? 5 : item}
                      </div>
                      {item}x
                    </button>
                  ))}
                </div>
              )} */}
        </>
      )}
      {getCase?.type === 3 && (
        <>
          <div className="case_actions_left_group"></div>
          <div className="case_actions_center_group">
            {!getProfile ? (
              <Button
                className={`btn1_yellow case_actions_button`}
                text={t('Login')}
                href={'/auth/steam'}
              />
            ) : (
              <OpenCase data-type="openCase" isFastEnd={true} />
            )}
          </div>
          <div className="case_actions_right_group">
            <OpenCase
              isDemo={true}
              isDemoDisabled={true}
              isFastEnd={false}
              data-type="demo"
            />

            <div className="case_actions_desktop_switch">
              <div className="sound_switch_container">
                <span className="fast_open_label">{t('Open quick')}</span>
                <Switch
                  defaultChecked={isFastGame}
                  icon={<SwitchIcon />}
                  className="sound_switch"
                  onChange={toogleFastMode}
                  isDisabled={isGame ? true : false}
                />
              </div>
            </div>
          </div>
        </>

        // <OpenCase
        //   disabled={disabled}
        //   className={`btn-buy ${
        //     getCase?.type === 3 && 'open_free_case_profil'
        //   }`}
        //   data-rar={getCase?.color}
        //   data-type="openCase"
        // >
        //   <div className="btn-hoykey">o</div>

        //   <div className="btn-sale-cost-wrap">
        //     {freeCountOpen > 0 && (
        //       <div className="btn-free-case-count">{freeCountOpen}</div>
        //     )}
        //     {getCase?.priceOld > 0 && (
        //       <div className="btn-sale-cost">
        //         {getConfig.isEU ? (
        //           <>
        //             <Currency />
        //             <Price sum={priceOld} />
        //           </>
        //         ) : (
        //           <>
        //             <Price sum={priceOld} />
        //             <Currency />
        //           </>
        //         )}
        //       </div>
        //     )}
        //     {battlePassCoins > 0 && (
        //       <div className="btn-coin-cost">
        //         <span>
        //           +<Price sum={battlePassCoins} />
        //         </span>
        //         <svg
        //           width="16"
        //           height="16"
        //           viewBox="0 0 16 16"
        //           fill="none"
        //           xmlns="http://www.w3.org/2000/svg"
        //         >
        //           <g opacity="0.5">
        //             <path
        //               fillRule="evenodd"
        //               clipRule="evenodd"
        //               d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM9 13.917C11.8377 13.441 14 10.973 14 8C14 5.027 11.8377 2.55904 9 2.08296V5H11L12 6H7L6 7V9L7 10H12L11 11H9V13.917ZM7 13.917V11H6L4 9V7L6 5H7V2.08296C4.16229 2.55904 2 5.027 2 8C2 10.973 4.16229 13.441 7 13.917Z"
        //               fill="white"
        //             ></path>
        //           </g>
        //         </svg>
        //       </div>
        //     )}
        //   </div>

        //   <span className="btn-buy-text">{t('Open')}</span>
        //   <span className="btn-buy-cost">
        //     {!getCase?.price || price <= 0 ? (
        //       <>
        //         {getConfig.isEU ? (
        //           <>
        //             <Currency />
        //             Free | 0
        //           </>
        //         ) : (
        //           <>
        //             Free | 0
        //             <Currency />
        //           </>
        //         )}
        //       </>
        //     ) : (
        //       <>
        //         {getConfig.isEU ? (
        //           <>
        //             <Currency />
        //             <Price sum={price} />
        //           </>
        //         ) : (
        //           <>
        //             <Price sum={price} />
        //             <Currency />
        //           </>
        //         )}
        //       </>
        //     )}
        //   </span>
        // </OpenCase>
      )}
      {/* {!gameStatus && getProfile?.money < price ? (
        <>
          <div className="case-select-count"></div>
          <div className="case-warning case-warning-dont-money">
            <span className="icon material-icons">campaign</span>
            <div className="case-warning-title">
              {t('Just a little to open the case')}!
            </div>
            {
              <div className="case-warning-text">
                {t('By replenishing the account at least')}{' '}
                {getConfig.isEU ? (
                  <>
                    <Currency />
                    <Price sum={price - getProfile?.money} />
                  </>
                ) : (
                  <>
                    <Price sum={price - getProfile?.money} />
                    <Currency />
                  </>
                )}{' '}
                {t(
                  'or by selling items for this amount, you can immediately open it',
                )}
                !
              </div>
            }
          </div>
          <a
            className="btn-pay btn-case-free popolnit_case"
            href="#"
            data-type="FundsModal"
            data-reachgoal="add_funds_case"
            onClick={viewModal}
            onMouseEnter={playAudio}
            data-audio="2.mp3"
            data-volume="0.20"
          >
            <div className="btn-hoykey">p</div>
            <div className="top"></div>
            <div className="top-2"></div>
            <div className="bot"></div>
            <div className="bot-2"></div>
            <div className="shadow"></div>
            <div className="shadow-2"></div>
            <div className="text">{t('Refill')}</div>
          </a>
        </>
      ) : (
        <OpenCase
          disabled={disabled}
          className={`btn-buy ${
            getCase?.type === 3 && 'open_free_case_profil'
          }`}
          data-rar={getCase?.color}
          data-type="openCase"
        >
          <div className="btn-hoykey">o</div>

          <div className="btn-sale-cost-wrap">
            {freeCountOpen > 0 && (
              <div className="btn-free-case-count">{freeCountOpen}</div>
            )}
            {getCase?.priceOld > 0 && (
              <div className="btn-sale-cost">
                {getConfig.isEU ? (
                  <>
                    <Currency />
                    <Price sum={priceOld} />
                  </>
                ) : (
                  <>
                    <Price sum={priceOld} />
                    <Currency />
                  </>
                )}
              </div>
            )}
            {battlePassCoins > 0 && (
              <div className="btn-coin-cost">
                <span>
                  +<Price sum={battlePassCoins} />
                </span>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g opacity="0.5">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM9 13.917C11.8377 13.441 14 10.973 14 8C14 5.027 11.8377 2.55904 9 2.08296V5H11L12 6H7L6 7V9L7 10H12L11 11H9V13.917ZM7 13.917V11H6L4 9V7L6 5H7V2.08296C4.16229 2.55904 2 5.027 2 8C2 10.973 4.16229 13.441 7 13.917Z"
                      fill="white"
                    ></path>
                  </g>
                </svg>
              </div>
            )}
          </div>

          <span className="btn-buy-text">{t('Open')}</span>
          <span className="btn-buy-cost">
            {!getCase?.price || price <= 0 ? (
              <>
                {getConfig.isEU ? (
                  <>
                    <Currency />
                    Free | 0
                  </>
                ) : (
                  <>
                    Free | 0
                    <Currency />
                  </>
                )}
              </>
            ) : (
              <>
                {getConfig.isEU ? (
                  <>
                    <Currency />
                    <Price sum={price} />
                  </>
                ) : (
                  <>
                    <Price sum={price} />
                    <Currency />
                  </>
                )}
              </>
            )}
          </span>
        </OpenCase>
      )} */}

      {/* {getCase?.type !== 6 && (
        <OpenCase
          data-rar={price <= 0 ? '06c50c' : getCase?.color}
          data-type="demo"
          className={`btn-demo b-violet b-violet-blue ${
            getProfile?.money < getCase?.price ? 'demover-0' : 'demover-1'
          }`}
        >
          <div className="btn-hoykey">d</div>
          {t('btn-demo b-violet b-violet-blue')}
        </OpenCase>
      )}

      {getCase?.type === 3 && !getProfile?.lastFreeGameDate ? null : (
        <div className="btn-fast-open">
          <span>{t('Open quick')}</span>
          <label className="switch" htmlFor="checkbox">
            <div className="btn-hoykey">q</div>
            <input
              type="checkbox"
              id="checkbox"
              onChange={toogleFastMode}
              defaultChecked={isFastGame}
            />
            <div className="switch-round"></div>
          </label>
        </div>
      )}
        */}
    </>
  );
};

export default ButtonsCase;
